'use client';

import { CircleHelp } from 'lucide-react';

import { STATUS_PALETTE } from '../lib/status-palette';

type QuizCardProps = {
	onOpen: () => void;
	status?: 'pending' | 'accepted' | null;
};

export function QuizCard({ onOpen, status }: QuizCardProps) {
	const st = status === 'accepted' ? STATUS_PALETTE.accepted : null;
	return (
		<button
			type="button"
			onClick={onOpen}
			className="flex w-full cursor-pointer items-center gap-3.5 rounded-lg border border-gray-4 bg-gray-4/30 py-3 pl-4 pr-3.5 text-left font-sans transition-all duration-150 hover:bg-gray-4/50"
		>
			<div className="relative h-[50px] w-10 shrink-0">
				<svg
					width="40"
					height="50"
					viewBox="0 0 40 50"
					fill="none"
					className="block"
				>
					<path
						d="M3.5 4 C3.5 2 5 0.5 7 0.5 L26 0.5 L39.5 14 L39.5 46 C39.5 48 38 49.5 36 49.5 L7 49.5 C5 49.5 3.5 48 3.5 46 Z"
						className="fill-white stroke-gray-4"
						strokeWidth="1"
					/>
					<path
						d="M26 0.5 L26 11 C26 12.66 27.34 14 29 14 L39.5 14"
						className="fill-gray-5 stroke-gray-4"
						strokeWidth="1"
						strokeLinejoin="round"
					/>
				</svg>
				<div className="absolute inset-0 flex items-center justify-center pt-1.5">
					<CircleHelp size={14} strokeWidth={2} className="text-gray-3" />
				</div>
			</div>

			<div className="min-w-0 flex-1">
				<span className="block truncate text-base font-medium text-black">
					Проверь себя
				</span>
				{st && (
					<span className={`text-sm font-medium ${st.cls}`}>{st.label}</span>
				)}
			</div>

			<div className="flex shrink-0 items-center rounded-md border border-gray-4 bg-white px-3 py-1.5 text-sm font-medium text-black">
				Открыть
			</div>
		</button>
	);
}
